import { Button, Form, Space } from "antd";
import _t from "../../lang/translate";
import { OpenModalProps } from "../../types/modalTypes";
import assertFC from "../../utilities/assertFC";
import { renderErrorMessage } from "../messages/errorMessage";
import InputVin from "../form/inputVin";


type FormType = {
  vinOverride: number | undefined
}
export default function OverrideAdvertVin<T extends object>({ onSuccess, onCancel, payload }: OpenModalProps<T>) {
  const [tmpForm] = Form.useForm<FormType>();

  const handleSubmit = (values: FormType) => {
    try {
      onSuccess(values as T);
    } catch (error) {
      renderErrorMessage(error)
    }
  };

  return (
    <Form form={tmpForm} requiredMark={false} layout="vertical" onFinish={handleSubmit}
      initialValues={{ vinOverride: payload?.vinOverride ?? undefined }}
    >
      <h2 className="modal-title">{_t("override", "vin")}</h2>
      <Form.Item name="vinOverride" label={_t("override", "vin")}>
        <InputVin />
      </Form.Item>
      <div className="text-right">
        <Space>
          <Button type="ghost" onClick={onCancel}>
            {_t("cancel")}
          </Button>
          <Button htmlType="submit" type="primary">
            {_t("save")}
          </Button>
        </Space>
      </div>
    </Form>
  );
}

assertFC(OverrideAdvertVin);
